<script setup lang="ts">
import { formatAnswerValue } from "@/shared/lib/format"

import type { LogAnswer } from "./answer"

defineProps<{ answers: LogAnswer[] }>()
</script>

<template>
  <dl v-if="answers.length" class="mt-3 divide-y divide-gray-100">
    <div v-for="answer in answers" :key="answer.rating_id" class="flex justify-between py-1.5 text-sm">
      <dt class="text-gray-600">{{ answer.prompt }}</dt>
      <dd class="font-medium">{{ formatAnswerValue(answer.value) }}</dd>
    </div>
  </dl>
</template>
